<mat-expansion-panel [expanded]="expanded">
  @if (groupCaptionVisible) {
    <mat-expansion-panel-header>{{captionText|translate}}</mat-expansion-panel-header>
  }

  @for (vmp of vmpList; track vmp) {
    <div [formGroup]='form' class='form-row'>
      <ldw-vmp-form-group-item [vmp]='vmp' [captionWidth]='captionWidth' [captionVisible]='captionVisible'>
        <div class='inner-control'>
          @if (isButtonEdit(vmp)) {
            <div>
              <ldw-button-edit (actionClicked)='actionClicked.emit($event)' [form]='form' [controlName]='vmp.fieldName' [vmp]='vmp'></ldw-button-edit>
            </div>
          }
          @if (isSelect(vmp)) {
            <div>
              <ldw-select-edit [form]='form' [controlName]='vmp.fieldName' [vmp]='vmp'></ldw-select-edit>
            </div>
          }
          @if (!isSelect(vmp) && !isButtonEdit(vmp)) {
            <div>
              <div>
                @switch (vmp.fieldType) {
                  @case (fldType.Character || fldType.Text) {
                    <ldw-lookup-edit [form]='form'
                      [controlName]='vmp.fieldName'
                    [vmp]='vmp'></ldw-lookup-edit>
                  }
                  @case (fldType.Boolean) {
                    <ldw-check-edit [form]='form' [controlName]='vmp.fieldName'
                    [vmp]='vmp'></ldw-check-edit>
                  }
                }
              </div>
            </div>
          }
        </div>
      </ldw-vmp-form-group-item>
    </div>
  }
</mat-expansion-panel>
